import { render, staticRenderFns } from "./table.vue?vue&type=template&id=cfc857ee&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfc857ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('cfc857ee')) {
      api.createRecord('cfc857ee', component.options)
    } else {
      api.reload('cfc857ee', component.options)
    }
    module.hot.accept("./table.vue?vue&type=template&id=cfc857ee&scoped=true", function () {
      api.rerender('cfc857ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pluginManage/pluginTactics/components/table.vue"
export default component.exports